import React from 'react'
import { graphql } from 'gatsby'
import BlogItem from '../components/BlogItem/BlogItem'
import { Link } from 'gatsby'
import Layout from '../components/Layout/Layout'
import { Helmet } from 'react-helmet'

const Blog = ({ data, pageContext }) => (
  <Layout title="College Pulse Blog">
    <Helmet>
      <script type="text/javascript">{'function initApollo(){var n=Math.random().toString(36).substring(7),o=document.createElement("script"); o.src="https://assets.apollo.io/micro/website-tracker/tracker.iife.js?nocache="+n,o.async=!0,o.defer=!0, o.onload=function(){window.trackingFunctions.onLoad({appId:"66294cedd50c9601c741a4d8"})}, document.head.appendChild(o)}initApollo();'}</script>
    </Helmet>
    <React.Fragment>
      <section className="has-background-primary has-padding-6 is-centered methodology-title is-flex-direction-column blog-header">
        <h1 className="title has-text-white has-text-weight-bold has-margin-top-4 has-margin-bottom-3">
          News & Research
        </h1>
        <div>
          <Link to={'/blog/featured/page/1'}>
            <button className="button">Featured</button>
          </Link>
          <Link to={'/blog/insights/page/1'}>
            <button className="button">Insights</button>
          </Link>
          <Link to={'/blog/press-releases/page/1'}>
            <button className="button">Press Releases</button>
          </Link>
          <Link to={'/blog/pulse-in-the-news/page/1'}>
            <button className="button">In The News</button>
          </Link>
        </div>
      </section>
      <main className="container has-padding-top-6 has-padding-bottom-6">
        <section className="columns is-multiline is-8 is-variable">
          {data.allWordpressPost.edges.map(post => (
            <BlogItem post={post.node} />
          ))}
        </section>

        <section className="has-margin-top-5" style={{ textAlign: 'center' }}>
          Currently on page {pageContext.currentPage} of {pageContext.pageCount}
          <br />
          {pageContext.currentPage !== 1 && (
            <Link className="has-margin-right-4" to={`/blog/page/${pageContext.currentPage - 1}`}>
              <strong>Newer Posts</strong>
            </Link>
          )}
          {pageContext.currentPage < pageContext.pageCount && (
            <Link to={`/blog/page/${pageContext.currentPage + 1}`}>
              <strong>Older Posts</strong>
            </Link>
          )}
        </section>
      </main>
    </React.Fragment>
  </Layout>
)

export const query = graphql`
  query ($skip: Int!, $limit: Int!) {
    allWordpressPost(
      filter: { title: { ne: "dummy" } }
      sort: { fields: [date], order: DESC }
      limit: $limit
      skip: $skip
    ) {
      edges {
        node {
          id
          date(formatString: "MMMM Do, YYYY")
          title
          excerpt
          slug
          link
          featured_media {
            localFile {
              childImageSharp {
                fluid {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }
    }
  }
`

export default Blog
